import type { ButtonDesignTokens } from '@primeuix/themes/types/button';

/**
 * Button component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/button/index.ts
 *
 * Component documentation:
 * https://primeng.org/button
 */
export const buttonComponentTokens: Partial<ButtonDesignTokens> = {
  root: {
    iconOnlyWidth: '35px',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    label: {
      fontWeight: '600',
    },
  },
  colorScheme: {
    light: {
      root: {
        primary: {
          background: '{blue.500}',
          hoverBackground: '{blue.600}',
          activeBackground: '{blue.700}',
          color: '{white}',
          borderColor: '{blue.500}',
          hoverBorderColor: '{blue.600}',
          activeBorderColor: '{blue.700}',
          focusRing: {
            color: '{blue.500}',
          },
        },
      },
      text: {
        primary: {
          color: '{blue.500}',
          hoverBackground: '{blue.50}',
          activeBackground: '{blue.100}',
        },
      },
      outlined: {
        primary: {
          color: '{blue.500}',
          borderColor: '{blue.500}',
          hoverBackground: '{blue.50}',
          activeBackground: '{blue.100}',
        },
      },
      link: {
        color: '{blue.500}',
        hoverColor: '{blue.600}',
        activeColor: '{blue.700}',
      },
    },
  },
};
